var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "asc__navigation-list" },
    [
      _vm._l(_vm.data, function(item, i) {
        return _c(
          "li",
          { key: "i" + i },
          [
            !item.sub.length >= 1
              ? [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        "active-class": "asc__navigation-active",
                        exact: "",
                        to: { name: item.router }
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.collapseNav()
                        }
                      }
                    },
                    [
                      _c("i", {
                        class: item.icon ? item.icon : _vm.defaultIcon
                      }),
                      _vm._v(" " + _vm._s(item.title))
                    ]
                  )
                ]
              : [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle",
                          value: "collapse-" + item.router,
                          expression: "'collapse-'+item.router"
                        }
                      ]
                    },
                    [
                      _c("i", {
                        class: item.icon ? item.icon : _vm.defaultIcon
                      }),
                      _vm._v(" " + _vm._s(item.title))
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    { attrs: { id: "collapse-" + item.router } },
                    [
                      _c(
                        "ul",
                        [
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    "active-class": "asc__navigation-active",
                                    exact: "",
                                    to: { name: item.router }
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.collapseNav()
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    class: item.icon
                                      ? item.icon
                                      : _vm.defaultIcon
                                  }),
                                  _vm._v(" " + _vm._s(item.title))
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(item.sub, function(sub, x) {
                            return _c(
                              "li",
                              { key: "x" + x },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      "active-class": "asc__navigation-active",
                                      exact: "",
                                      to: { name: sub.router }
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.collapseNav()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      class: sub.icon
                                        ? sub.icon
                                        : _vm.defaultIcon
                                    }),
                                    _vm._v(" " + _vm._s(sub.title))
                                  ]
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ]
                  )
                ]
          ],
          2
        )
      }),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "d-block d-md-none" },
        [
          _c("b-button", [
            _c("i", { staticClass: "fas fa-sign-out-alt" }),
            _vm._v(" " + _vm._s(_vm.$t("nav.logout")))
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09c1da02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c1da02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationList.vue
// module id = null
// module chunks = 